import { PluginType } from '@deephaven/plugin';
import ChartBuilderPlugin from "./ChartBuilderPlugin.js";
var ChartBuilderPluginConfig = {
  name: 'ChartBuilderPlugin',
  type: PluginType.DASHBOARD_PLUGIN,
  component: ChartBuilderPlugin
};
export default ChartBuilderPluginConfig;
//# sourceMappingURL=ChartBuilderPluginConfig.js.map